import { combineReducers } from 'redux'
import roles from './roles'
import info from './info'
import settings from './settings'
import selection from './selection'

export default combineReducers({
  roles,
  info,
  settings,
  selection,
})
